import React from "react";

import { CCard, CBadge, CProgress, CCardFooter } from "@coreui/react";

import "./styles.css";

const ExperimentCard = props => (
  <CCard className="newton-experiment-card cursor" onClick={props.onClick}>
    <div className="newton-img-container">
      <img src={props.image} alt={props.name} />
    </div>
    <CCardFooter className="flex-column">
      <div className="w-100 d-flex align-items-center mb-2">
        <CProgress
          color="warning"
          value={props.progress}
          style={{ width: "100%", height: "4px" }}
        />
        <span className="small text-muted ml-2">{props.progress}%</span>
      </div>
      <div className="w-100 mb-3">
        <div className="font-weight-bold">{props.name}</div>
        <div className="text-muted small text-ellipsis">
          {props.description}
        </div>
      </div>
      <div className="w-100 d-flex justify-content-between align-items-center">
        <CBadge color="light" className="p-2 d-flex align-items-center">
          <i className="fa fa-user mr-2"></i>
          {props.type}
        </CBadge>
      </div>
    </CCardFooter>
  </CCard>
);

export default ExperimentCard;
